import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';
import XMLParser from '@kazukinagata/react-xml-parser';
import {useTranslation} from 'react-i18next';
import {REACT_APP_QURAN_LEFT_FRAME, REACT_APP_QURAN_RIGHT_FRAME} from '../../../page/tools/quran/CONSTANTS';
import {QuranDetailModel, QuranMainModel} from '../../../page/tools/quran/quran.model';
import {ContainerComponent} from '../../../core/components/container.component';
import {toPersianNumber, toPersianNumberFromNumber} from '../../../core/utils/number.utils';
import {AppDispatch} from '../../../core/redux/store';
import {Loader} from '../../../core/components/loader.component';
import {SearchFiled} from '../../../core/components/searchFiled.component';
import {checkQuranSoreListIncludeSearchString} from '../../../page/tools/quran/quran.utils';
import {
  getAyeBookmark,
  getGhari,
  getQuranFontSize,
  getSoreBookmark,
  isTranslateEnable,
  isVoiceTranslateEnable,
  isWbwEnable,
  saveBookmarkParams,
  saveGhari,
  saveQuranFont,
  saveTranslateEnable,
  saveVoiceTranslateEnable,
  saveWbwEnable
} from '../../../core/services/localStorage.service';
import {ColumnComponent} from '../../../core/components/base/column.component';
import {RowComponent} from '../../../core/components/base/row.component';
import {GetStaticProps, NextPage} from 'next';
import axios from 'axios';
import {DATA_BASE_ADDRESS} from '../../../page/tools/drug_store/CONSTANTS';
import {FormControlLabel, InputLabel, MenuItem, Select, SelectChangeEvent, SwipeableDrawer} from '@mui/material';
import {PERSIAN} from '../../../core/services/CONSTANTS';
import {MESSAGE_ACTION} from '../../../core/redux/reducers/messageActions';
import {BackIconComponent} from '../../../core/components/backIcon.component';
import PlayArrowRounded from '@mui/icons-material/PlayCircleOutlineRounded';
import PauseArrowRounded from '@mui/icons-material/PauseCircleOutlineRounded';
import ReactPlayer from 'react-player';
import LayoutDrawer from '../../../core/components/layoutDrawer.component';
import CloseIcon from '@mui/icons-material/CloseRounded';
import {BlueSwitch} from '../../../core/components/ui/CustomSwitch';
import {RTLContainer} from '../../../core/components/RTLContainer.component';
import {CustomFormControl} from '../../../core/components/customFormControl.component';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {QURAN} from '../../../core/navigation/CONSTANTS';
import {useRouter} from 'next/router';
import {CONTAINER_ACTION} from '../../../page/Main/redux/mainAction';

interface Props {
  quran: QuranDetailModel[];
  quranTranslate: QuranDetailModel[];
}

const QuranIndex: NextPage<Props> = (props) => {
  const topRef = React.useRef<HTMLInputElement>(null);
  const [searchSubject, setSearchSubject] = useState('');
  const [bookmark, setBookmark] = useState('');
  const [isSoreDetail, setSoreDetail] = useState(false);
  const [soreDetailId, setSoreDetailId] = useState(-1);
  const [quranTranslateList, setQuranTranslateList] = useState<QuranDetailModel[]>([]);
  const [quranSoreList, setQuranSoreList] = useState<QuranDetailModel[]>([]);
  const [quranSearchSoreList, setQuranSearchSoreList] = useState<QuranDetailModel[]>([]);
  const { t, i18n } = useTranslation();
  const [voiceUrl, setVoiceUrl] = useState('');
  const [playing, setPlaying] = useState(false);
  const [trackNumber, setTrackNumber] = useState<number>(0);
  const [wordNumber, setWordNumber] = useState<number>(0);
  const [wordId, setWordId] = useState<string>('');
  const [wordTotalNumber, setWordTotalNumber] = useState<number>(0);
  const [settingOpen, setSettingOpen] = useState(false);
  const [translateVisible, setTranslateVisible] = useState(true);
  const [voiceTranslateEnable, setVoiceTranslateEnable] = useState(false);
  const [wbwEnable, setWbwEnable] = useState(false);
  const [gharis] = useState<string[]>(t('qhariArray', { returnObjects: true }));
  const [voicePathArray] = useState<string[]>(t('voicePathArray', { returnObjects: true }));
  const [ghariValue, setGhariValue] = useState<string>();
  const inputRefs = useMemo(() => Array.from({ length: 300 }).map(() => React.createRef<HTMLDivElement>()), []);
  const [fontArray] = useState<string[]>(t('fontArray', { returnObjects: true }));
  const [fontSize, setFontSize] = useState<string>();
  const router = useRouter();
  let dispatch = useDispatch<AppDispatch>();

  const handleChangeGhari = (event: SelectChangeEvent) => {
    setGhariValue(event.target.value);
    saveGhari(String(event.target.value));
  };

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    saveTranslateEnable(event.currentTarget.checked ? '1' : '0');
    setTranslateVisible(event.currentTarget.checked ?? true);
  };

  const handleChangeVoiceTranslate = (event: React.FormEvent<HTMLInputElement>) => {
    saveVoiceTranslateEnable(event.currentTarget.checked ? '1' : '0');
    setVoiceTranslateEnable(event.currentTarget.checked ?? false);
  };

  const handleChangeWBW = (event: React.FormEvent<HTMLInputElement>) => {
    saveWbwEnable(event.currentTarget.checked ? '1' : '0');
    setWbwEnable(event.currentTarget.checked);
  };

  function playClick(index: number) {
    if (index === 0) {
      setTrackNumber(index - 1);
      chooseTrackVoiceUrl(index - 1);
    } else {
      setTrackNumber(index);
      chooseTrackVoiceUrl(index);
    }
    setPlaying(true);
  }

  function wordClick(i: number, index: number, total: number) {
    if (wbwEnable) {
      chooseVoiceUrl(i, index);
      setTrackNumber(index);
      setWordNumber(i);
      setWordTotalNumber(total);
      setPlaying(true);
    } else {
      playClick(index);
    }
  }

  function pauseClick(index: number) {
    setTrackNumber(index);
    setPlaying(false);
  }

  const handleChangeFont = (event: SelectChangeEvent) => {
    setFontSize(event.target.value);
    saveQuranFont(Number(event.target.value).toString());
  };

  function chooseVoiceUrl(wordNumber: number, trackNumber: number) {
    setWordNumber(wordNumber);
    setTrackNumber(trackNumber);
    setWordId(
      `${String(soreDetailId + 1).padStart(3, '0')}_${String(trackNumber + 1).padStart(3, '0')}_${String(
        wordNumber + 1
      ).padStart(3, '0')}`
    );
    const voice = `https://verses.quran.com/wbw/${String(soreDetailId + 1).padStart(3, '0')}_${String(
      trackNumber + 1
    ).padStart(3, '0')}_${String(wordNumber + 1).padStart(3, '0')}.mp3`;
    setVoiceUrl(voice);
  }

  function chooseTrackVoiceUrl(trackNumber: number) {
    setTrackNumber(trackNumber);
    setWordId('');
    const voice = `https://tanzil.net/res/audio/${voicePathArray[Number(getGhari())]}/${String(soreDetailId + 1).padStart(
      3,
      '0'
    )}${String(trackNumber + 1).padStart(3, '0')}.mp3`;
    setVoiceUrl(voice);
  }

  function chooseTrackVoiceTranslateUrl(trackNumber: number) {
    setTrackNumber(trackNumber);
    setWordId('');
    const voice = `https://tanzil.net/res/audio/fa.fooladvand/${String(soreDetailId + 1).padStart(
        3,
        '0'
    )}${String(trackNumber + 1).padStart(3, '0')}.mp3`;
    setVoiceUrl(voice);
  }

  function addBookmark() {
    setBookmark(soreDetailId.toString() ?? '')
    saveBookmarkParams(soreDetailId.toString() ?? '', trackNumber.toString());
    dispatch({
      type: MESSAGE_ACTION,
      message: t('bookmarkSuccess'),
      sort: 'success'
    });
  }

  useEffect(() => {
    setSoreDetail(false);
    if (typeof window !== 'undefined') window.scrollTo({ behavior: 'smooth', top: 0, left: 0 });
    setBookmark(getSoreBookmark());
    setQuranSoreList(props.quran);
    setQuranSearchSoreList(props.quran);
    setQuranTranslateList(props.quranTranslate);
    setWbwEnable(isWbwEnable() === '1');
    setTranslateVisible(isTranslateEnable() === '1' && i18n.language === PERSIAN);
    setVoiceTranslateEnable(isVoiceTranslateEnable() === '1' && i18n.language === PERSIAN);
    if (getGhari().includes(".mp3")) {
      saveGhari("abdulbasit");
      setGhariValue("abdulbasit");
    } else {
      setGhariValue(getGhari());
    }
    setFontSize(getQuranFontSize());
    setWbwEnable(isWbwEnable() === '1');
    setTranslateVisible(isTranslateEnable() === '1');
  }, []);

  useEffect(() => {
    if (router.query.id) {
      if (typeof window !== 'undefined') window.scrollTo({ behavior: 'smooth', top: 0, left: 0 });
      setSoreDetail(true);
      setPlaying(false);
      setSoreDetailId(Number(router.query.id));
    } else {
      setSoreDetail(false);
      setPlaying(false);
      setSoreDetailId(-1);
      dispatch({
        type: CONTAINER_ACTION,
        state: ''
      });
    }
  }, [router.query]);

  useEffect(() => {
    if (isSoreDetail) {
      if (getSoreBookmark() === soreDetailId.toString() && inputRefs[Number(getAyeBookmark())].current) {
        // @ts-ignore
        inputRefs[Number(getAyeBookmark())].current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        setTrackNumber(Number(getAyeBookmark()));
      } else {
        setTrackNumber(0);
        // @ts-ignore
        inputRefs[0].current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  }, [isSoreDetail]);

  const handleChangeSubject = (event: React.FormEvent<HTMLInputElement>) => {
    setSearchSubject(event.currentTarget.value);
    setQuranSearchSoreList(checkQuranSoreListIncludeSearchString(quranSoreList, event.currentTarget.value));
  };

  function goToBookmarkPage() {
    dispatch({
      type: CONTAINER_ACTION,
      state: t('shName.quran')
    });
    router.push(
      { pathname: QURAN, search: `id=${Number(bookmark)}` },
      undefined,
      { shallow: true }
    );
  }

  function navigateToSore(item: QuranDetailModel) {
    router.push(
      {
        pathname: QURAN,
        search: `id=${Number(item.attributes.index) - 1}`
      },
      undefined,
      { shallow: true }
    );
  }

  function backClick() {
    setSoreDetail(false);
    setSoreDetailId(-1);
    dispatch({
      type: CONTAINER_ACTION,
      state: ''
    });
    router.back();
  }

  function openSettingClick() {
    setSettingOpen(true);
  }

  function closeSettingClick() {
    setSettingOpen(!settingOpen);
  }

  return (
    <ContainerComponent hasResponsivePadding={true}>
      {quranSoreList ? (
        isSoreDetail && soreDetailId >= 0 ? (
          <ColumnComponent className="background">
            <ColumnComponent className="items-center">
              <RowComponent className="relative items-center sticky top-0 background p-1">
                <BackIconComponent
                  onClick={() => {
                    backClick();
                  }}
                />
                <div className="text-bold grow text-lg">
                  {t('religious.sore')} {quranSoreList[soreDetailId].attributes.name}
                </div>
                <div className="flex flex-row totalCenter">
                  <div
                    onClick={() => {
                      addBookmark();
                    }}
                    className="fs-7 text-bold btn mText pointer"
                  >
                    {t('bookmark')}
                  </div>
                  <div
                    onClick={() =>
                      openSettingClick()
                    }
                    className="text-base text-bold btn mText mx-2 pointer"
                  >
                    {t('setting')}
                  </div>
                </div>
              </RowComponent>
              <div className="w-full m-2 separatorLine" />
              <ColumnComponent className="px-3 container">
                {quranSoreList[soreDetailId].children.map((item: QuranDetailModel, index: number) => (
                  <div key={index} ref={inputRefs[index]}>
                    <div
                      style={{ display: item.attributes.bismillah ? 'block' : 'none' }}
                      className="text-bold text-base mb-3 text-center"
                    >
                      {item.attributes.bismillah}
                    </div>
                    <RowComponent>
                      <div className="grow flex flex-col justify-center">
                        <div
                          className={`flex flex-row pointer flex-wrap text-bold btn text-right text-bold fs-${
                            5 + (Number(fontSize) ?? 1)
                          }`}
                        >
                          {item.attributes.text.split(' ').map((span, i) => (
                            <span
                              className={
                                `${String(soreDetailId + 1).padStart(3, '0')}_${String(index + 1).padStart(
                                  3,
                                  '0'
                                )}_${String(i + 1).padStart(3, '0')}` === wordId
                                  ? 'mTextRed'
                                  : trackNumber === index
                                  ? 'mTextBlue'
                                  : 'mText'
                              }
                              onClick={() => wordClick(i, index, item.attributes.text.split(' ').length)}
                            >
                              {span}&nbsp;
                            </span>
                          ))}
                        </div>
                        <div style={{ display: translateVisible ? 'block' : 'none' }} className={`fs-7 p-1 ${((trackNumber === index)&&voiceUrl.includes("fooladvand"))?"mTextBlue":"mTextLight"}`}>
                          {quranTranslateList[soreDetailId] && quranTranslateList[soreDetailId].children[index]
                            ? quranTranslateList[soreDetailId].children[index].attributes.text
                            : ''}
                        </div>
                      </div>
                      <div className="flex flex-col items-center soreDetailPlayIndexFrame">
                        <div className="fs-9 mText">{toPersianNumberFromNumber(index + 1)}</div>
                        <PlayArrowRounded
                          fontSize={'large'}
                          onClick={() => playClick(index)}
                          style={{
                            display: !playing || trackNumber !== index ? 'block' : 'none'
                          }}
                          className="mt-2 pointer"
                        />
                        <PauseArrowRounded
                          fontSize={'large'}
                          onClick={() => pauseClick(index)}
                          style={{
                            display: playing && trackNumber === index ? 'block' : 'none'
                          }}
                          className="mt-2 mTextBlue pointer"
                        />
                        <div className="fs-7 mb-1">
                          {t('religious.joz')}
                          {toPersianNumber(item.attributes.joz)}
                        </div>
                      </div>
                    </RowComponent>
                    <div className="separatorLine mt-3 mb-3" />
                  </div>
                ))}
              </ColumnComponent>
              <ReactPlayer
                width={'100%'}
                height={'3rem'}
                prelaod={'none'}
                muted={false}
                stopOnUnmount={false}
                playing={playing}
                onReady={() => {}}
                className="hidden"
                onEnded={() => {
                  if (quranSoreList[soreDetailId].children.length >= trackNumber + 1) {
                    if (!wbwEnable) {
                      // @ts-ignore
                      inputRefs[trackNumber + 1].current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                      });
                      if (voiceTranslateEnable &&!voiceUrl.includes("fooladvand")) {
                        chooseTrackVoiceTranslateUrl(trackNumber)
                      }else{
                        chooseTrackVoiceUrl(trackNumber + 1);
                      }
                    } else {
                      if (wordTotalNumber > wordNumber) {
                        chooseVoiceUrl(wordNumber + 1, trackNumber);
                      } else {
                        // @ts-ignore
                        inputRefs[trackNumber + 1].current.scrollIntoView({
                          behavior: 'smooth',
                          block: 'center'
                        });
                        setWordTotalNumber(
                          quranSoreList[soreDetailId].children[trackNumber + 1].attributes.text.split(' ').length
                        );
                        chooseVoiceUrl(0, trackNumber + 1);
                      }
                      setPlaying(true);
                    }
                  }
                }}
                onError={() => {
                  if (wbwEnable) {
                    if (wordTotalNumber > wordNumber) {
                      chooseVoiceUrl(wordNumber + 1, trackNumber);
                    } else {
                      // @ts-ignore
                      inputRefs[trackNumber + 1].current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                      });
                      setWordTotalNumber(
                        quranSoreList[soreDetailId].children[trackNumber + 1].attributes.text.split(' ').length
                      );
                      chooseVoiceUrl(0, trackNumber + 1);
                    }
                    setPlaying(true);
                  }
                  if (trackNumber === -1) {
                    chooseTrackVoiceUrl(0);
                  }
                }}
                pip={true}
                url={voiceUrl}
                autoPlay={true}
                controls={false}
              />
            </ColumnComponent>
            <SwipeableDrawer
              anchor={'bottom'}
              open={settingOpen}
              PaperProps={{ square: false, elevation: 0, style: { backgroundColor: 'transparent' } }}
              onOpen={() => setSettingOpen(true)}
              onClose={() => closeSettingClick()}
            >
              <LayoutDrawer>
                <CloseIcon fontSize={'large'} onClick={() => setSettingOpen(false)} className="closeIcon" />
                <ColumnComponent dir={i18n.language == PERSIAN ? 'rtl' : 'ltr'} className="px-3 mt-16 mb-3">
                  <FormControlLabel className={"px-4"}
                    style={{ display: i18n.language == PERSIAN ? 'flex' : 'none' }}
                    control={<BlueSwitch size={'small'} checked={translateVisible} onChange={handleChange} />}
                    label={<div>{t('religious.farsiTranslate')}</div>}
                  />
                  <FormControlLabel className={"mt-4 px-4"}
                      style={{ display: i18n.language == PERSIAN ? 'flex' : 'none' }}
                      control={<BlueSwitch size={'small'} checked={voiceTranslateEnable} onChange={handleChangeVoiceTranslate} />}
                      label={<div>{t('religious.voiceFarsiTranslate')}</div>}
                  />
                  <FormControlLabel
                    className="mt-4 mb-2 px-4"
                    control={<BlueSwitch size={'small'} checked={wbwEnable} onChange={handleChangeWBW} />}
                    label={<div>{t('religious.wordByWord')}</div>}
                  />
                  <RTLContainer>
                    <CustomFormControl className="fullWidth px-3 !mt-3" variant="outlined">
                      <InputLabel className="mText">{t('religious.chooseGhari')}</InputLabel>
                      <Select
                        IconComponent={() => <ExpandMoreIcon className="mText" fontSize={'medium'} />}
                        onChange={handleChangeGhari}
                        value={ghariValue}
                        className="w-full"
                      >
                        {gharis.map((gr, index) => (
                          <MenuItem className="w-full font" value={index}>
                            {gr}
                          </MenuItem>
                        ))}
                      </Select>
                    </CustomFormControl>
                    <CustomFormControl className="fullWidth px-3 !mt-5" variant="outlined">
                      <InputLabel className="mText">{t('religious.fontSize')}</InputLabel>
                      <Select
                        IconComponent={() => <ExpandMoreIcon className="mText" fontSize={'medium'} />}
                        onChange={handleChangeFont}
                        value={fontSize}
                        className="w-full"
                      >
                        {fontArray
                          ? fontArray.map((size, index) => (
                              <MenuItem key={index} className="w-full font" value={index}>
                                {size}
                              </MenuItem>
                            ))
                          : null}
                      </Select>
                    </CustomFormControl>
                  </RTLContainer>
                </ColumnComponent>
              </LayoutDrawer>
            </SwipeableDrawer>
          </ColumnComponent>
        ) : (
          <ColumnComponent ref={topRef} className="container-lg totalCenter background">
            <div className={`mt-2 w-full`}>
              <SearchFiled
                searchTag={t('religious.searchInSubject')}
                type={'text'}
                searchText={searchSubject}
                onChangeText={handleChangeSubject}
              />
            </div>
            {bookmark ? (
              <div className="w-full text-center text-bold text-base mt-1 pointer" onClick={() => goToBookmarkPage()}>
                {t('goToBookmark')}
              </div>
            ) : null}
            <ColumnComponent className="mt-1 px-2">
              {quranSearchSoreList && quranSearchSoreList.length > 0 ? (
                quranSearchSoreList.map((item: QuranDetailModel, index: number) => (
                  <RowComponent key={index} className="totalCenter py-1 px-2" style={{ direction: 'rtl' }}>
                    <img
                      alt="right"
                      className="frameImage"
                      style={{ width: '3.2rem', height: '3.2rem' }}
                      src={REACT_APP_QURAN_RIGHT_FRAME}
                    />
                    <RowComponent
                      onClick={() => {
                        navigateToSore(item);
                      }}
                      className="btn mBorder p-1 pointer"
                    >
                      <RowComponent className="items-center">
                        <div className="p-1 text-base mText w-auto">{toPersianNumberFromNumber(index + 1)}</div>
                        <div className="p-1 text-lg me-1 mText text-start w-auto">
                          {t('religious.sore')} {item.attributes.name}
                        </div>
                        <div className="grow" />
                        <div className="w-auto fs-7 mText flex flex-col items-center">
                          <div>
                            {t('religious.joz')} {toPersianNumber(item.attributes.joz)}
                          </div>
                          <div>
                            {toPersianNumberFromNumber(item.children.length)} {t('religious.aye')}{' '}
                          </div>
                        </div>
                      </RowComponent>
                    </RowComponent>
                    <img
                      alt="left"
                      className="frameImage"
                      style={{ width: '3.2rem', height: '3.2rem' }}
                      src={REACT_APP_QURAN_LEFT_FRAME}
                    />
                  </RowComponent>
                ))
              ) : (
                <Loader isFullScreen={false} />
              )}
            </ColumnComponent>
          </ColumnComponent>
        )
      ) : null}
    </ContainerComponent>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const res = await axios.get(DATA_BASE_ADDRESS + 'quran.xml');
  const resTranslate = await axios.get(DATA_BASE_ADDRESS + 'quran_farsi.xml');
  let quranModel: QuranMainModel = new XMLParser().parseFromString(res.data.toString()) as QuranMainModel;
  let quranTranslateModel: QuranMainModel = new XMLParser().parseFromString(
    resTranslate.data.toString()
  ) as QuranMainModel;
  return {
    props: {
      quran: quranModel.children,
      quranTranslate: quranTranslateModel.children
    }
  };
};

export default QuranIndex;
